var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormbgblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1171,
    height: 571,
    viewBox: "0 0 1171 571",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1171 226.093C1142.28 226.093 1119 252.949 1119 286.077C1119 319.205 1142.28 346.061 1171 346.061V571H0V346.061C28.7188 346.061 52 319.205 52 286.077C52 252.949 28.7188 226.093 0 226.093V0H1171V226.093Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1120 25V230.1C1093.49 230.713 1072.4 255.653 1072.4 286.028C1072.4 316.403 1093.49 341.343 1120 341.956V546H50V341.956C76.5055 341.343 97.6035 316.403 97.6035 286.028C97.6035 255.653 76.5055 230.713 50 230.1V25H1120Z",
    fill: "#1E1E1E",
    stroke: "#F0E1CE",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormbgblack);
export default __webpack_public_path__ + "static/media/formbgblack.3582523ea07d250009c59ccc175c74b5.svg";
export { ForwardRef as ReactComponent };